import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'
Vue.use(Router)

// const getUrlCode = function (url, code) {
//   const rag = new RegExp('(^|&)' + code + '=([^&]*)(&|$)', 'i')
//   const result = url.match(rag)
//   return result ? result[2] : null
// }

function beforeEach (to, from, next) {
  document.title = to.meta.title
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.path])
    }
  }
  const app = this.app
  app.$isLoggedIn().then(() => {
    const token = localStorage.getItem('token')
    let toQuery = JSON.parse(JSON.stringify(to.query))
    if (token) {
      toQuery.token = token
    }
    if (toQuery.token) {
      next()
    } else {
      next({
        name: to.name,
        query: toQuery
      })
    }
  }).catch(() => {
    // this.$set(to)
    next(to.meta.loginType
      ? undefined
      : { name: 'login', query: { redirect: to.fullPath } }
    )
  })
}

function afterEach (to) {
  const app = this.app
  const breadcrumb = to.matched.slice(1).map(({ name, meta }) => {
    return {
      name: meta.title,
      to: name
        ? { name }
        : undefined
    }
  })
  app.$nextTick(() => {
    app.$bus.$emit('breadcrumb-change', breadcrumb)
  })
}

const router = new Router({
  mode: 'history',
  routes
})
router.beforeEach(beforeEach.bind(router))
router.afterEach(afterEach.bind(router))
// 路由导航冗余报错（路由重复）
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
